import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolla in alto SOLO al cambio di pathname (nuova pagina).
 * NON scrolla se cambiano solo i search params (filtri, sort, etc.),
 * così i pannelli filtri restano stabili durante l'interazione.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Usa scrollTo istantaneo (non smooth) per evitare percezione "salta"
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}
